import * as React from "react";
const SvgAirplane = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.722-.001a.75.75 0 0 0-.672 1.02l2.75 7.1a.75.75 0 0 0 .579.469l7.472 1.211c.186.03.168.084.168.2s.018.167-.168.2L3.38 11.41a.75.75 0 0 0-.579.469l-2.75 7.1a.75.75 0 0 0 1.034.941l18.5-9.25a.75.75 0 0 0 0-1.342L1.084.079a.75.75 0 0 0-.362-.08" }));
export default SvgAirplane;
